import { ReactElement } from 'react';

interface ArrowDownProps {
  yCoordinate?: number;
  xCoordinate?: number;
}

function ArrowDown({ yCoordinate, xCoordinate }: ArrowDownProps): ReactElement {
  return (
    <>
      <polygon
        transform={`translate(${xCoordinate}, ${yCoordinate}) rotate(0 0 0) scale(1)`}
        points='0,0 5,0 2.5,5'
        stroke='white'
        fill='white'
      />
    </>
  );
}

export default ArrowDown;
